'use client';

import { useEffect } from 'react';

import { useIsLogin } from '@/store/user';
import { logH5PageOpen } from '@/utils/tracker/global-info';

/**
 * 全局 H5_OPEN 埋点 Hook
 *
 * @description
 * - 系统首次访问：localStorage，仅一次；URL 有 landing 归因则带上
 * - 切后台再回前台：sessionStorage 标记，用户首次 click/touch/keydown 后再上报
 *
 * 须在根布局单例挂载（如 GlobalTrackerSync），重复挂载会重复注册 document 监听（cleanup 可恢复）
 *
 * 刻意行为：
 * 1. 同会话可出现两条 H5_OPEN：冷启动首次访问 + 后续「后台 → 回前台 → 交互」各一条
 * 2. 刷新/冷启动会清除 session 待交互标记，不回补刷新前未交互的回前台上报
 * 3. 仅监听 visibility hidden 置位，不在 visible 时上报；回前台只看屏不操作则不上报
 */
export function useGlobalTracker(): void {
    const isLoggedIn = useIsLogin();

    useEffect(() => {
        logH5PageOpen(isLoggedIn);

        // 仅 hidden 时置位；不在 visible 时自动上报，等用户首次交互（刻意行为）
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                logH5PageOpen(isLoggedIn);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [isLoggedIn]);
}
